import { render, staticRenderFns } from "./TextView.vue?vue&type=template&id=031f9f28&scoped=true"
import script from "./TextView.vue?vue&type=script&lang=js"
export * from "./TextView.vue?vue&type=script&lang=js"
import style0 from "./TextView.vue?vue&type=style&index=0&id=031f9f28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031f9f28",
  null
  
)

export default component.exports